import PropTypes from 'prop-types';

export const propTypes = {
    title: PropTypes.string,
    languageLocale: PropTypes.string,
    elementsList: PropTypes.array,
    customImages: PropTypes.array,
    defaultImages: PropTypes.array,
    disableWhiteLabel: PropTypes.bool,
    defaultTemplatesList: PropTypes.array,
    customTemplatesList: PropTypes.array,
    templatesDisplayOrder: PropTypes.oneOf(['defaultFirst', 'customFirst']),
    askDeleteConfirmation: PropTypes.bool,
    showOutsideBoundaryPreview: PropTypes.bool,
    outsideBoundaryPreviewPadding: PropTypes.number,
    qrLink: PropTypes.string,
    styleProps: PropTypes.object,
    defaultText: PropTypes.string,
    onSave: PropTypes.func,
    saveButtonText: PropTypes.string,
    locale: PropTypes.oneOf(['en', 'ru', 'pl', 'de', 'es', 'fr', 'it']),
    canvasSize: PropTypes.shape({
        mode: PropTypes.oneOf(['preset', 'custom']),
        preset: PropTypes.string,
        widthMm: PropTypes.number,
        heightMm: PropTypes.number,
    }),
    onCanvasSizeChange: PropTypes.func,
};
